import { useTranslation } from "react-i18next";
import { dirOf, setLocale } from "../i18n";
import type { Locale } from "../lib/types";

export function useLocale() {
  const { i18n } = useTranslation();
  const locale: Locale = i18n.language === "en" ? "en" : "ar";
  return { locale, dir: dirOf(locale), isRtl: locale === "ar", setLocale };
}
